//
// forms/index.js - top-level import for forms
//

import './utm-saver';                                                // i.e: save utm_source=facebook into localStoarge
import '../../../site--brandwatch.com/js/start-trial/start_trial'    // Imported here because it contains functions that have to be loaded before the marketo submit callback functin TODO: Needs refactoring 
import './js-mkto-form';                                             // i.e: A standard Marketo form
import './js-email-prefill-form';                                    // i.e: open email field - like on buzzsumo.com
import './js-prefill-data-extractor';                                // i.e: "Thanks ${localStorage.name}!"
import './stripe';
